<template>
  <div :class="['tree-node', { 'tree-node-inline': inLineDisplay }, { 'ml-12': leftMargin }]">
    <span v-for="(values, i) in valuesPerBloc" :key="i" class="tree-node">
      <!--Affichage des valuers par bloc-->
      <span :key="index" :class="{
        'lang-container': true,
        'filter-lang-dedicated': isUnlocalizedValue(value),
        ['filter-lang-dedicated-' + (value.lang ? value.lang.toUpperCase() : 'UND')]: isUnlocalizedValue(value)
      }" v-for="(value, index) in values">


        <div class="display-flew-row">
          <!--Affichage de l'opérande logique-->
          <template v-if="axiomLogicOperand">
            <span class="axiome-logique-operand ml-5" v-text="i != 0 ? axiomLogicOperand : ' '" />
          </template>
          <span v-if="level0" :class="['property-value-prefix']">&nbsp;&nbsp;&nbsp;</span>
          <span v-if="showLanguageBadge && isUnlocalizedValue(value)" class="lang-badge">
            {{ (value.lang === "" || value.lang === "und") ? "" : value.lang.toUpperCase() }}
          </span>
          <div v-if="value.content"
            :class="['text-break', 'property-value-content', 'ml-2', { 'font-italic': value.individual || false }]"
            v-html="value.content" />
          <div v-else :class="['text-break', 'property-value-content']" v-html="value" />
          <AxiomAnnotation v-if="value.axiomAnnotations && value.axiomAnnotations.length"
            :axiomAnnotations="value.axiomAnnotations" :aProposDe="predicat + ' - ' + value.content"
            :axiomLogicOperand="axiomLogicOperand" />
        </div>

      </span>
    </span>
  </div>
</template>

<script>
import Utils from "../../utils";
export default {
  name: "PropertyValue",

  props: {
    predicat: {
      type: String,
      default: ''
    },
    inLineDisplay: {
      type: Boolean,
      default: false
    },
    axiomLogicOperand: {
      type: String,
      default: ''
    },
    values: Array,
    leftMargin: {
      type: Boolean,
      default: true
    },
    treeDisplay: {
      type: Boolean,
      default: false
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    level0: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    valuesPerBloc() {
      return this.extractValuePerBloc();
    }
  },
  methods: {
    isUnlocalizedValue(value) {
      return Utils.isUnlocalizedValue(value);
    },

    extractValuePerBloc() {
      // creation d'une liste de liste de value par blocNumber
      const valuePerBloc = new Map();
      this.values.forEach(value => {

        if (valuePerBloc.get(value.blocNumber)) {
          valuePerBloc.get(value.blocNumber).push(value);
        } else {
          valuePerBloc.set(value.blocNumber, [value]);
        }
      });

      let result = [];
      valuePerBloc.forEach((value) => {
        result.push(value);
      });
      return result;
    }
  },
}
</script>
<style lang="scss" scoped>
.tree-node-inline {
  display: flex;
  flex-direction: row;
}

.display-flew-row {
  display: flex;
  flex-direction: row
}

::v-deep span.lang-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 23px;
  min-width: 23px;
  height: 23px;
  min-height: 23px;
  margin-right: 15px;
  padding: 0;
  border-radius: 50px;
  text-align: center;
  border: 1px solid var(--v-tertiary-base);
  font-size: 10px;
  letter-spacing: normal;
  font-weight: 500;
  color: var(--v-tertiary-base);
}
</style>
